import { useFetchSavedFeeds } from '../../api-services/feeds/useFetchSavedFeeds';
import PostCard from './home-components/PostCard';
import { SITELINK } from '../../app-routes/Links';
import TopBar from '../../layouts/~includes/TopBar';
import { useTheme } from '../../context/theme-context';
import { SkeletonFeed } from '../../components/skeletons';
import { useEffect, useState } from 'react';
import { getUser } from '../../app-utils';
import { UserInterface } from '../../app-schemas/profile.schema';

// main-component-ui
const SavedPost = () => {
  document.body.classList.remove('overflow-hidden');
  
  const [user, setUser] = useState<UserInterface | null>(null);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const { isDarkMode } = useTheme();
  const posts = useFetchSavedFeeds();

  // Load user data safely
  useEffect(() => {
    const loadUser = () => {
      const userData = getUser();
      setUser(userData);
      setIsLoadingUser(false);
    };
    loadUser();
  }, []);

  // Show loading state while checking user
  if (isLoadingUser) {
    return (
      <section className={`min-h-screen ${isDarkMode ? 'bg-neutral-900' : 'bg-[#E1F0F8F7]'}`}>
        <div className="fixed top-0 w-full z-50">
          <TopBar title='Saved' link={SITELINK.HOME}/>
        </div>
        <div className="mt-[50px] mb-20">
          <SkeletonFeed count={3} variant="post" />
        </div>
      </section>
    );
  }

  // Handle case where user is not logged in
  if (!user) {
    return (
      <section className={`min-h-screen ${isDarkMode ? 'bg-neutral-900' : 'bg-[#E1F0F8F7]'}`}>
        <div className="fixed top-0 w-full z-50">
          <TopBar title='Saved' link={SITELINK.HOME}/>
        </div>
        <div className="flex items-center justify-center h-[calc(100vh-50px)] mt-[50px]">
          <div className="text-center">
            <p className={`mb-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              Please log in to view your saved posts
            </p>
            <a href={SITELINK.LOGIN} className="text-blue-600 hover:underline">
              Go to Login
            </a>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`min-h-screen ${isDarkMode ? 'bg-neutral-900' : 'bg-[#E1F0F8F7]'}`}>
      {/* top lead area and post btn */}
      <div className="fixed top-0 w-full z-50">
        <TopBar title='Saved' link={SITELINK.HOME}/>
      </div>

      {/* community feeds section */}
      <div className="mt-[50px] mb-20">
        {posts.isLoading ? (
          <SkeletonFeed count={3} variant="post" />
        ) : (
          <>
            {posts?.data?.length > 0 ? (
              posts?.data?.map((item: any, index: number) => (
                <PostCard 
                  key={index} 
                  index={index} 
                  post={item.post[0]} 
                />
              ))
            ) : (
              <div className="flex flex-col items-center justify-center h-[60vh] gap-4">
                <div className="text-center">
                  <svg 
                    className={`w-16 h-16 mx-auto mb-4 ${isDarkMode ? 'text-gray-600' : 'text-gray-400'}`}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={1.5} 
                      d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" 
                    />
                  </svg>
                  <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                    No saved posts yet
                  </p>
                  <p className={`text-xs mt-2 ${isDarkMode ? 'text-gray-500' : 'text-gray-400'}`}>
                    Save posts you like to see them here
                  </p>
                  <a 
                    href={SITELINK.HOME}
                    className="inline-block mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
                  >
                    Browse Posts
                  </a>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default SavedPost;